import { useContext, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import ChannelContext from '@jetshop/core/components/ChannelContext';
import SiteContentContext from '../SiteContent/SiteContentContext';
import { useB2BChannel } from '../Layout/Header/ChannelSelector/useB2BChannel';

const DISMISS_COOKIE_NAME = 'mp_customer_type_dismissed';
//BROWSERS CAP COOKIES AT 400 DAYS, SO THE COOKIE IS RENEWED ON EVERY VISIT TO NEVER EXPIRE FOR RETURNING VISITORS
const DISMISS_COOKIE_MAX_AGE = 60 * 60 * 24 * 400;

let cookieRenewed = false;

//SHARED BY THE POPUP AND KLAVIYO, SO KLAVIYO CAN WAIT UNTIL THE VISITOR HAS CHOSEN
export const useCustomerTypePopup = () => {
  const { selectedChannel } = useContext(ChannelContext);
  const { showCustomerTypePopup } = useContext(SiteContentContext) || {};
  const [cookies, setCookie] = useCookies([DISMISS_COOKIE_NAME]);
  const { isB2B } = useB2BChannel();

  const isSwedishB2C =
    !!selectedChannel && !isB2B && selectedChannel.country?.code === 'SE';
  const isDismissed = !!cookies[DISMISS_COOKIE_NAME];
  const shouldShow = !!showCustomerTypePopup && isSwedishB2C && !isDismissed;

  const saveDismissCookie = () => {
    setCookie(DISMISS_COOKIE_NAME, '1', {
      path: '/',
      maxAge: DISMISS_COOKIE_MAX_AGE,
    });
  };

  //RENEW ONCE PER PAGE LOAD, EVEN THOUGH THE HOOK IS USED IN SEVERAL COMPONENTS
  useEffect(() => {
    if (!isDismissed || cookieRenewed) return;
    cookieRenewed = true;
    saveDismissCookie();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDismissed]);

  return { shouldShow, saveDismissCookie };
};
